import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label`
  display: block;
  max-width: 100%;
  margin-bottom: 5px;
  color: ${props => props.theme.colors.black};
  font-size: inherit;
`;
const StyledTextarea = styled.textarea`
  background-color: ${props => props.theme.colors.surfaceElevated};
  border-radius: 6px;
  appearance: none;
  color: ${props => props.theme.colors.black};
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  padding: 14px;
  width: 100%;
  border: 1px solid ${p => p.theme.colors.borderSubtle};
  margin-bottom: 20px;

  &:active:not([disabled]),
  &:focus:not([disabled]),
  &:hover:not([disabled]) {
    border: 1px solid ${p => p.theme.colors.deepGrey};
  }

  &:focus-visible:not([disabled]) {
    outline: 2px solid ${p => p.theme.colors.focusRing};
    outline-offset: 1px;
  }

  &[disabled] {
    background-color: ${p => p.theme.colors.inputDisabledBg};
  }
`;

const StyledRequiredMark = styled.span`
  color: ${p => p.theme.colors.danger};
`;

export const Textarea = ({ labelText, required, ...props }: any) => (
  <>
    <StyledLabel>
      {labelText}
      {required && <StyledRequiredMark> *</StyledRequiredMark>}
    </StyledLabel>
    <StyledTextarea {...props} />
  </>
);
